import styled, {css} from 'styled-components';

import OutputText from '@ey/canvascoreservices/OutputText';
import Icon from '@ey/canvascoreservices/Icon';

const styles = css`
	--size: var(--px-24);
	--color: transparent;
	--border-color: transparent;
	--background-color: transparent;
	height: var(--size);
	width: var(--size);
	display: flex;
	justify-content: center;
	align-items: center;
	border: var(--border-width-large) solid var(--border-color);
	border-radius: var(--border-radius-small);
	color: var(--color);
	background-color: var(--background-color);
	justify-self: center;
	&.not-relevant {
		--color: var(--neutrals-900);
	}
	&.higher {
		--color: var(--neutrals-50);
		--border-color: var(--maroon-500);
		--background-color: var(--maroon-500);
	}
	&.risk-higher {
		--size: var(--px-13);
		--border-color: var(--maroon-500);
		--background-color: var(--maroon-500);
		border-radius: 50%;
	}
	&.lower {
		--color: var(--neutrals-700);
		--border-color: var(--maroon-500);
	}
	&.risk-lower {
		--size: var(--px-8);
		--border-color: var(--neutrals-700);
		--background-color: var(--neutrals-700);
		border-radius: 50%;
	}
	&.incomplete {
		--color: var(--orange-500);
	}
`;

export default styled(OutputText)`
	${styles}
`;

export const StyledRelatedRiskIndicatorIcon = styled(Icon)`
	${styles}
`;
